import { render } from "./HomePaperCenter.vue?vue&type=template&id=2e60959a&scoped=true"
import script from "./HomePaperCenter.vue?vue&type=script&lang=js"
export * from "./HomePaperCenter.vue?vue&type=script&lang=js"

import "./HomePaperCenter.vue?vue&type=style&index=0&id=2e60959a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e60959a"]])

export default __exports__